'use client'
import { Box, Button, Flex, Text, useDisclosure } from '@chakra-ui/react'
import { useWindowScroll } from '@uidotdev/usehooks'
import { Icons } from '../icons'
import { useEffect, useRef, useState } from 'react'
import Link from 'next/link'
import { useUser } from '@/src/store/user-store'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/navigation'
import VideoUploadFlow from '../upload/videouploadflow'

export const BottomNav: React.FC = () => {
  const [{ y }] = useWindowScroll()
  const pathname = usePathname()
  const [showBottomBar, setShowBottomBar] = useState<boolean>(true)
  const lastScrollYRef = useRef<number | null>(null)
  const { user } = useUser()
  useEffect(() => {
    if (y && y <= 60) {
      setShowBottomBar(true)
      return
    }
    if ((y || 0) > (lastScrollYRef.current || 0)) {
      setShowBottomBar(false)
    } else {
      setShowBottomBar(true)
    }
    lastScrollYRef.current = y
  }, [y])

  const { isOpen, onOpen, onClose } = useDisclosure()
  const router = useRouter()

  return (
    <Box
      key="bottom-nav"
      position="fixed"
      bottom={showBottomBar ? '0' : '-140px'}
      left="0"
      w="100vw"
      h="80px"
      bg="#fff"
      zIndex={998}
      transition="0.3s ease-in-out"
      borderTop="2px solid"
      borderColor="gray.100"
      hideFrom="md"
    >
      <VideoUploadFlow onOpen={onOpen} onClose={onClose} isOpen={isOpen} />

      <Flex
        justifyContent="space-around"
        alignItems="center"
        px={3}
        h="full"
        w="full"
        columnGap={0}
      >
        <Flex
          flexDir="column"
          alignItems="center"
          rowGap={'0px'}
          w="20%"
          color={pathname == '/home' ? 'lyk-green' : 'gray.600'}
        >
          <Link href="/home" className="flex flex-col items-center">
            <Icons.Home className="h-[30px] w-[30px]" />
            <Text
              fontSize="sm"
              className={pathname == '/home' ? 'font-semibold' : ''}
            >
              Home
            </Text>
          </Link>
        </Flex>
        <Flex
          flexDir="column"
          alignItems="center"
          rowGap={'0px'}
          w="20%"
          color={pathname == '/rewards' ? 'lyk-green' : 'gray.600'}
        >
          <Link
            href={user ? '/earnings' : '/auth/login'}
            className="flex flex-col items-center"
          >
            <Icons.Wallet className="h-[30px] w-[30px]" />
            <Text
              fontSize="sm"
              className={pathname == '/rewards' ? 'font-semibold' : ''}
            >
              Earnings
            </Text>
          </Link>
        </Flex>
        <Box position="relative">
          <Flex
            position="absolute"
            zIndex={1001}
            height="70px"
            width="70px"
            rounded="full"
            bg="lyk-green"
            left="-35px"
            top="-75px"
            justifyContent="center"
            alignItems="center"
            shadow="0px 0px 30px 2px rgba(36,191,163,0.8) !important"
            style={{
              boxShadow: '0px 0px 15px 0px rgba(36,191,163,0.63) !important',
            }}
          >
            <Button
              onClick={() => {
                if (user !== null) {
                  onOpen()
                } else {
                  router.push('/auth/login')
                }
              }}
              variant={'unstyled'}
            >
              <Icons.CamPlus className="h-[40px] w-[40px] text-white" />
            </Button>
          </Flex>
        </Box>

        <Flex
          flexDir="column"
          alignItems="center"
          rowGap={'0px'}
          w="20%"
          color={pathname == '/subscriptions' ? 'lyk-green' : 'gray.600'}
        >
          <Link
            href={user ? '/subscriptions' : '/auth/login'}
            className="flex flex-col items-center"
          >
            <Icons.UserCheck className="h-[30px] w-[30px]" />
            <Text
              fontSize="sm"
              className={pathname == '/subscriptions' ? 'font-semibold' : ''}
            >
              Subscriptions
            </Text>
          </Link>
        </Flex>
        <Flex
          flexDir="column"
          alignItems="center"
          rowGap={'0px'}
          w="20%"
          color={pathname == '/account' ? 'lyk-green' : 'gray.600'}
        >
          <Link
            href={user ? '/account' : '/auth/login'}
            className="flex flex-col items-center"
          >
            <Icons.User className="h-[30px] w-[30px]" />
            <Text
              fontSize="sm"
              className={pathname == '/account' ? 'font-semibold' : ''}
            >
              Profile
            </Text>
          </Link>
        </Flex>
      </Flex>
    </Box>
  )
}
